module.exports = __webpack_public_path__ + "static/media/folder-with-file.f0459a37.svg";